// for production use
export const BASE_URL = "https://just-camera-442001-t3.uc.r.appspot.com/api";
// for backenddevelopment test use
// export const BASE_URL = "https://opulent-sniffle-4jqpv4px5r9x35q94-3000.app.github.dev/api";